import { Injectable, signal } from '@angular/core';

const DEFAULT_BOT_NAME = 'CORRA';

@Injectable({
    providedIn: 'root',
})
export class AiChatDockService {
    readonly isVisible = signal(false);
    readonly isLoading = signal(false);
    readonly messageToSend = signal<string | null>(null);
    readonly newChatRequestId = signal(0);
    readonly botName = signal(DEFAULT_BOT_NAME);

    open(): void {
        this.isVisible.set(true);
    }

    close(): void {
        this.isVisible.set(false);
    }

    toggle(): void {
        this.isVisible.update(isVisible => !isVisible);
    }

    setIsLoading(isLoading: boolean): void {
        this.isLoading.set(isLoading);
    }

    setMessageToSend(message: string | null): void {
        this.messageToSend.set(message);
    }

    startNewSessionWithMessage(message: string): void {
        this.newChatRequestId.update(id => id + 1);
        this.messageToSend.set(message);
        this.open();
    }
}
